import { FC } from 'react';

interface TestimonyItemProps {
  item: {
    id: string;
    name: string;
    division: string;
    number: string;
    title: string;
    description: string;
  };
}

const TestimonyItem: FC<TestimonyItemProps> = ({ item }) => {
  return (
    <div className="item-container">
      <div className="item-user">
        <div>
          <img
            src={`/assets/testimony/${item.id}.png`}
            width={133}
            height={133}
            alt={`testimony-${item.id}`}
          />
        </div>
        <div>
          <div className="item-name">{item.name}</div>
          <div>{item.division}</div>
        </div>
      </div>
      <div className="item-content">
        <h1 className="text-orange-1 item-number">{item.number}</h1>
        <h5 className="item-title">{item.title}</h5>
        <div>{item.description}</div>
      </div>
    </div>
  );
};

export { TestimonyItem };
